<template>
  <div class="d-roll-wrapper" v-bind:style="{textAlign: digitRollTextAlign}">
    <ul ref="list" :class="!isFixed ? 'd-roll-list number_flex1' : 'd-roll-list d-roll-list-left'" v-bind:style="{ transform: 'rotate(' + rotate + 'deg)', opacity: opacity }">
      <template v-if="options.showIcon && getIconPosition === 'left' && !onWarningStatus">
        <cxIcon class="icon" v-if="iconType === 'icon'" :options="options" :iconStyle="getIconStyle"></cxIcon>
        <img class="icon" v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
      </template>
      <template v-if="options.showIcon && getIconPosition === 'left' && onWarningStatus">
        <cxIcon class="icon" v-if="warningIconType === 'icon'" :options="options" :iconStyle="getIconStyle" iconSrcName="warningIconSrc"></cxIcon>
        <img class="icon" v-else-if="warningIconType === 'img' && warningIconSrc" :src="warningIconSrc" :style="getIconImgStyle" />
      </template>
      <span v-if="getShowPrefix" :style="getPrefixStyle">{{ getPrefixContent }}</span>
      <template v-for="(item, i) of digitOffsetArr">
        <li v-if="digitsArray[i] !== '.' && digitsArray[i] !== ','" class="d-roll-item" :style="getLiStyle">
          <div class="d-roll-bar" :style="getLiDivStyle(item, i)">
            <div v-for="(div, i) in divList" :key="i" :style="getDivStyle">{{ div }}</div>
          </div>
        </li>
        <div v-else :style="getOtherSymbolStyle">
          {{ digitsArray[i] }}
        </div>
      </template>
      <span v-if="getShowSuffix" :style="getSuffixStyle">{{ getSuffixContent }}</span>
      <template v-if="options.showIcon && getIconPosition === 'right' && !onWarningStatus">
        <cxIcon class="icon" v-if="iconType === 'icon'" :options="options" :iconStyle="getIconStyle"></cxIcon>
        <img class="icon" v-else-if="iconType === 'img' && iconSrc" :src="iconSrc" :style="getIconImgStyle" />
      </template>
      <template v-if="options.showIcon && getIconPosition === 'right' && onWarningStatus">
        <cxIcon class="icon" v-if="warningIconType === 'icon'" :options="options" :iconStyle="getIconStyle" iconSrcName="warningIconSrc"></cxIcon>
        <img class="icon" v-else-if="warningIconType === 'img' && warningIconSrc" :src="warningIconSrc" :style="getIconImgStyle" />
      </template>
    </ul>
  </div>
</template>

<script>
import { easeToCubicMap, arrayFromCache, supportCssCache, callExp } from "utils/index"
import { Tween } from "utils/Tween"

let rollLock = false;
let supportCss = supportCssCache
const FRAME_TIME = 1000 / 60
const defaultFlipStra = (before, next) => {
  if (next < before) {
    return true
  }
  return false
}

export default {
  name: "DigitRollCore",

  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    rollDigits: {
      type: [String, Number],
      default: 1000
    },
    dur: {
      type: Number,
      default: 1000
    },
    flipStra: {
      type: [Function, Boolean],
      default: null
    },
    easeFn: {
      type: [String],
      default: "Cubic.easeInOut"
    },
    getHeight: {
      type: Number,
      default: 0
    },
    getShowPrefix: {
      type: Boolean,
      default: false
    },
    getPrefixContent: {
      type: String,
      default: ""
    },
    getShowSuffix: {
      type: Boolean,
      default: false
    },
    getSuffixContent: {
      type: String,
      default: ""
    },
    getPrefixStyle: {
      type: Object,
      default: null
    },
    getLiStyle: {
      type: Object,
      default: null
    },
    getDivStyle: {
      type: Object,
      default: null
    },
    getOtherSymbolStyle: {
      type: Object,
      default: null
    },
    getSuffixStyle: {
      type: Object,
      default: null
    },
    isFixed: {
      type: Boolean,
      required: false,
      default: false
    },
    digitRollTextAlign: {
      type: String,
      required: false
    },
    rotate: {
      type: Number,
      required: false
    },
    opacity: {
      type: Number,
      required: false
    }
  },

  data() {
    const { rollDigits, flipStra } = this
    let executeStra = null

    if (typeof flipStra === "boolean") {
      executeStra = () => flipStra
    } else {
      executeStra = flipStra || defaultFlipStra
    }

    return {
      digits: `${rollDigits}`,
      digitsArray: [],
      beforeDigits: "0",
      cellHeight: 0,
      maxDur: 0,
      divList: arrayFromCache(10).map((n, i) => i),
      digitStatArr: [],
      digitOffsetArr: [],
      isWarning: false,
      // rollLock: false,
      executeStra
    }
  },

  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    getIconPosition() {
      return this.options ? this.options.iconPosition : "left"
    },
    iconType() {
      return this.options ? this.options.iconType : "img"
    },
    iconSrc() {
      return this.options ? this.options.iconSrc : ""
    },
    getMargin() {
      let iconMarginBottom = this.options.iconMarginBottom
      if(this.options.iconMarginBottom === undefined){
        iconMarginBottom = 0
      }
      let marginStr = ""
      if(this.isFixed){
        marginStr = this.options.iconPosition === "left"
            ? `${iconMarginBottom}px ${this.options.iconMargin}px 0 0`
            : `${iconMarginBottom}px 0 0 ${this.options.iconMargin}px`
      }else{
        marginStr = this.options.iconPosition === "left"
            ? `0 ${this.options.iconMargin}px ${iconMarginBottom}px 0`
            : `0 0 ${iconMarginBottom}px ${this.options.iconMargin}px`
      }
      return marginStr
    },
    getIconStyle() {
      // let color1 = this.options.iconColorIsThemeColor
      //     ? this.themeColor
      //     : this.options.iconColor && this.options.iconColor.color
      //         ? this.options.iconColor.color
      //         : this.options.iconColor
      let color1 = this.$parseColor(this.options.iconColor, {
        isThemeColor: this.options.iconColorIsThemeColor
      })
      if(this.isWarning){
        // color1 = this.options.warningIconColorIsThemeColor
        //     ? this.themeColor
        //     : this.options.warningIconColor && this.options.warningIconColor.color
        //         ? this.options.warningIconColor.color
        //         : this.options.warningIconColor
        color1 = this.$parseColor(this.options.warningIconColor, {
          isThemeColor: this.options.warningIconColorIsThemeColor
        })
      }
      return {
        display: "inline-block",
        "--color": color1,
        fontSize: this.options.iconSize + "px",
        width: this.options.iconSize + "px",
        height: this.options.iconSize + "px",
        margin: this.getMargin
      }
    },
    getIconImgStyle() {
      return {
        width: this.options.iconSize + "px",
        margin: this.getMargin
      }
    },
    // 是否开启了预警状态 且 有条件数据
    onWarningStatus(){
      if (this.options.onWarning && this.options.dynamicData && this.options.dynamicData.length > 0) {
        return true
      }else{
        return false
      }
    },
    warningIconSrc: {
      get() {
        let warningIconSrc = this.options.iconSrc
        if(this.isWarning){
          warningIconSrc = this.options.warningIconSrc
        }
        return warningIconSrc
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningIconSrc", false)
      }
    },
    warningIconColor: {
      get() {
        return this.options.warningIconColor || this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningIconColor", false)
      }
    },
    warningIconColorIsThemeColor: {
      get() {
        return this.options.warningIconColorIsThemeColor || this.options.iconColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningIconColorIsThemeColor", false)
      }
    },
    warningIconType: {
      get() {
        let warningIconType = this.options.iconType
        if(this.isWarning){
          warningIconType = this.options.warningIconType
        }else{
          this.$changeOptionsEV(this.options.iconSrc, "warningIconSrc", false)
        }
        return warningIconType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "warningIconType", false)
      }
    },
  },
  watch: {
    rollDigits(value, oldVal) {
      // if (rollLock) {
      //   return;
      // }
      value = value + ""
      this.digitsArray = value.split("")
      const oldLen = `${oldVal}`.length
      const newLen = `${value}`.length
      this.digits = `${value}`
      if (oldLen !== newLen) {
        this.resetStat(newLen);
      }
      if(value !== oldVal){
        this.updateDynamicData(Number(this.digits))
      }
    },
    getHeight: function (value, oldVal) {
      this.cellHeight = value
      this.resetStat(this.digits.length)
    },
    "options.dynamicData": {
      handler(n, o) {
        this.updateDynamicData(Number(this.digits))
      },
      deep: true
    }
  },

  methods: {
    getOtherSymbolTimes() {
      const temp = this.digits.split("")
      let count = 0
      for(let i = 0; i < temp.length; i++) {
        if (temp[i] === "," || temp[i] === ".") {
          count++
        }
      }
      return count
    },
    resetStat(len) {
      const newArr = arrayFromCache(len)
      this.digitOffsetArr = newArr.map(() => 0)
      this.digitStatArr = newArr.map(() => ({ figure: 0, noTransition: true }))
      this.beforeDigits = newArr.map(() => 0).join("")
      setTimeout(() => {
        this.traverseChar()
      }, 50)
    },

    getLiDivStyle(item, i) {
      const transformPrefix = supportCss("transform")
      if (transformPrefix) {
        this.getLiDivStyle = function getTransformStyle(tItem, ti) {
          const offset = tItem ? `${tItem}px` : "0px"
          const value = `translateY(${offset}) translateZ(0)`
          const curStat = this.digitStatArr[ti]
          const easeFn = curStat.easeFn || this.easeFn
          const transitionFunc = easeToCubicMap[easeFn] || easeFn
          const msDur = curStat.dur || this.dur
          const sDurStr = `${msDur / 1000}s`
          const transProperty = typeof transformPrefix !== "boolean" ? `-${transformPrefix}-transform` : "transform"
          const transStyles = !curStat.noTransition
            ? {
                transition: `${transProperty} ${sDurStr} ${transitionFunc}`
              }
            : {}
          /** Vue会自动侦测并添加相应的前缀,无需自己添加属性前缀  */
          return {
            ...transStyles,
            transform: value,
            height: this.cellHeight + "px"
          }
        }
      } else {
        this.getLiDivStyle = function getMarginStyle(mItem) {
          const offset = mItem ? `${mItem}px` : "0px"

          return {
            marginTop: offset
          }
        }
      }

      this.getLiDivStyle(item, i)
    },

    getComplete(total) {
      let count = 0
      const vm = this
      return function completeRoll() {
        if (++count >= total) {
          vm.beforeDigits = `${vm.digits}`
          setTimeout(() => {
            // rollLock = false;
            vm.$emit("roll-finish")
          }, 4)
        }
      }
    },

    traverseChar(opts = null) {
      const vm = this
      const { digitStatArr, digits, beforeDigits, executeStra } = vm
      const completeRoll = vm.getComplete(digitStatArr.length - vm.getOtherSymbolTimes())
      // rollLock = true;
      vm.$emit("roll-start")

      digitStatArr.forEach((stat, i) => {
        let dis = 0
        const before = beforeDigits.charAt(i)
        const next = digits.charAt(i)
        const opt = opts instanceof Array ? opts[i] : {}
        const optFlipStra = typeof opt.flipStra === "boolean" ? () => opt.flipStra : opt.flipStra
        const needFlip = optFlipStra ? optFlipStra(before, next) : executeStra(before, next)

        if (needFlip) {
          dis = ~~next + 10 - before
          vm.digitStatArr[i].flip = true
        } else {
          dis = next - before
        }

        if (supportCss("transform")) {
          stat.noTransition = !!0
          vm.beginCssRoll(dis, i, completeRoll, opt)
        } else {
          vm.beginRoll(dis, i, completeRoll, opt)
        }
      })
    },

    beginCssRoll(dis, i, cb, opt) {
      const vm = this
      const transitionPrefix = supportCss("transition")
      const transitionEnd = (function whichTransitionEvent(prefix) {
        const pre = prefix.toLowerCase()
        if (typeof prefix === "boolean" || pre === "moz") {
          return "transitionend"
        }
        return `${pre}TransitionEnd`
      })(transitionPrefix)
      //开始执行滚动
      this.beginCssRoll = (aDis, ai, aCb, aOpt) => {
        const { cellHeight, digitStatArr, digitOffsetArr, dur: defaultDur, getShowPrefix } = vm
        const curStat = digitStatArr[ai]
        const rollOffset = cellHeight * aDis
        const beforeOffset = curStat.figure || 0
        const prePageOffset = cellHeight * 10 // 单倍模板距离
        const $list = vm.$refs.list
        let temp_ai = ai
        if (getShowPrefix) {
          temp_ai++
        }
        // 显示图标后需要排除
        if(this.options.showIcon && vm.getIconPosition === "left"){
          temp_ai++
        }
        const $curBar = $list?.querySelector(`li:nth-child(${temp_ai + 1}) .d-roll-bar`)
        if (!$curBar) return // ','、'.'不参与滚动

        if (rollOffset === 0) {
          aCb && aCb(i)
          return
        }

        curStat.figure = beforeOffset - rollOffset
        curStat.dur = aOpt.dur || defaultDur

        vm.$set(digitOffsetArr, ai, beforeOffset - rollOffset)

        //监听动画结束
        $curBar.addEventListener(transitionEnd, function transitionDone() {
          if (curStat.flip) {
            const overOffset = curStat.figure
            curStat.figure = overOffset + prePageOffset
            curStat.noTransition = !!1
            curStat.flip = !!0
          }

          vm.$set(digitOffsetArr, ai, curStat.figure)
          $curBar.removeEventListener(transitionEnd, transitionDone)
          aCb && aCb(i)
        })
      }

      this.beginCssRoll(dis, i, cb, opt)
    },

    beginRoll(dis, i, cb, opt) {
      const vm = this
      const { cellHeight, digitStatArr, maxDur, dur: defaultDur } = vm
      const start = 0
      const rollOffset = cellHeight * dis
      const dur = opt.dur || defaultDur
      const judgeFinish = Math.max(dur, maxDur)
      const curStat = digitStatArr[i]
      const beforeOffset = curStat.figure || 0
      const prePageOffset = cellHeight * 10

      let now = 0
      let easeFn = callExp(Tween, opt.easeFn || vm.easeFn)
      easeFn = easeFn || Tween.Cubic.easeInOut

      function step() {
        const offset = Math.min(easeFn(now, start, rollOffset, dur), rollOffset)
        curStat.figure = beforeOffset - offset

        if (now === judgeFinish && curStat.flip) {
          const overOffset = curStat.figure
          curStat.figure = overOffset + prePageOffset
          curStat.flip = !!0
        }

        /** optimize combo one frame reflow by vue */
        if (i === digitStatArr.length - 1) {
          vm.digitOffsetArr = digitStatArr.map(item => item.figure)
        }

        if (now === judgeFinish) {
          cb && cb(i)
          return
        }

        now += FRAME_TIME

        if (now < judgeFinish) {
          requestAnimationFrame(step)
        } else {
          now = judgeFinish
          requestAnimationFrame(step)
        }
      }

      step()
    },

    /** for user */
    setDigit(digit, opt) {
      const vm = this
      let opts = null
      // if (rollLock) {
      //   return;
      // }
      /** formate opts */
      if (typeof digit === "string" || typeof digit === "number") {
        vm.digits = `${digit}`
        if (opt) {
          opts = arrayFromCache(vm.digits.length).map(() => opt)
        }
      } else if (digit instanceof Array) {
        vm.digits = digit
          .map(({ value, dur }) => {
            if (dur > vm.maxDur) {
              vm.maxDur = dur
            }
            return value
          })
          .join("")
        opts = digit
      }
      if (vm.digits.length !== vm.beforeDigits.length) {
        vm.resetStat(vm.digits.length);
      }
    },

    // 警告数据
    updateDynamicData(contentValue) {
      if(!this.onWarningStatus){
        return
      }
      this.getResultObj()
      this.isWarning = false
      // 遍历动态数据条件
      for (let i = 0; i < this.options.dynamicData.length; i++) {
        const dynamicDataItem = this.options.dynamicData[i]
        switch (dynamicDataItem.condition) {
          case "等于":
            if (contentValue === Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "不等于":
            if (contentValue !== Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "大于等于":
            if (contentValue >= Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "小于等于":
            if (contentValue <= Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "大于":
            if (contentValue > Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "小于":
            if (contentValue < Number(dynamicDataItem.parameter)) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
          case "介于":
            if (
                contentValue > Number(dynamicDataItem.conditionRange[0]) &&
                contentValue <= Number(dynamicDataItem.conditionRange[1])
            ) {
              this.getResultObj(dynamicDataItem)
              this.isWarning = true
              continue
            }
            break
        }
      }
    },
    getResultObj(dynamicDataItem){
      if(dynamicDataItem){
        this.warningIconSrc = dynamicDataItem.resultIconSrc
        this.warningIconType = dynamicDataItem.resultIconType
        this.warningIconColor = dynamicDataItem.resultIconColor
        this.warningIconColorIsThemeColor = dynamicDataItem.resultIconColorIsThemeColor
      }else{
        this.$changeOptionsEV(this.options.iconSrc, "warningIconSrc", false, null, this.myid, true)
        this.$changeOptionsEV(this.options.iconType, "warningIconType", false, null, this.myid, true)
        this.$changeOptionsEV(this.options.iconColor, "warningIconColor", false, null, this.myid, true)
        this.$changeOptionsEV(this.options.iconColorIsThemeColor, "warningIconColorIsThemeColor", false, null, this.myid, true)
      }
    }
  },

  created() {
    this.digitsArray = this.rollDigits.toString().split("")
  },

  mounted() {
    this.cellHeight = this.getHeight
    this.resetStat(this.digits.length)
    this.updateDynamicData(Number(this.digits))
  }
}
</script>

<style>
.d-roll-wrapper {
  width: 100%;
}
.d-roll-list {
  margin: 0 auto;
  padding: 0;
  text-align: center;
  display: flex;
  overflow: hidden;
  align-items: flex-end;
}
.d-roll-list.number_flex1 {
  display: flex;
}
.d-roll-list .d-roll-item {
  list-style: none;
  float: left;
  flex-grow: 1;
  overflow: hidden;
}
.d-roll-list-left .icon{
  float: left;
}
.d-roll-list .d-roll-item:last-child {
  margin-right: 0 !important;
}
.d-roll-item > .d-roll-bar {
  backface-visibility: hidden;
  perspective: 1000;
}
.d-roll-item > .d-roll-bar > div {
  box-sizing: border-box !important;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
